import { computed } from 'vue'
import { featureRoleAliases } from '@/utils/featureRoleAliases'

export const ACCESS_LEVELS = ['READER', 'EDITOR', 'CREATOR', 'ADMIN'] as const
export type AccessLevel = (typeof ACCESS_LEVELS)[number]

export const getLevelIndex = (level?: string): number => {
  if (!level) return -1
  return ACCESS_LEVELS.indexOf(level as AccessLevel)
}

export const useAccessControl = (featureType: string) => {
  const maxAccessIndex = computed(() => {
    const roleStore = localStorage.getItem('roles') || '[]'
    const roles = JSON.parse(roleStore) as string[]

    const prefixes = featureRoleAliases(featureType).map((key) => `FEAT_${key}_`)

    const accessLevels = roles
      .map((role) => {
        const prefix = prefixes.find((p) => role.startsWith(p))
        return prefix ? (role.slice(prefix.length) as AccessLevel) : undefined
      })
      .filter((level): level is AccessLevel => !!level && ACCESS_LEVELS.includes(level))

    return Math.max(...accessLevels.map((lvl) => ACCESS_LEVELS.indexOf(lvl)), -1)
  })

  const hasAccess = (requiredLevel?: AccessLevel): boolean => {
    if (!requiredLevel) return true

    if (!ACCESS_LEVELS.includes(requiredLevel as AccessLevel)) return false

    const requiredIndex = ACCESS_LEVELS.indexOf(requiredLevel as AccessLevel)
    return requiredIndex <= maxAccessIndex.value
  }

  return {
    maxAccessIndex,
    hasAccess,
    getLevelIndex,
    ACCESS_LEVELS
  }
}
